import { Component, OnInit, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CompanyDeleteAccDialog } from '../delete-ctas/deleteacc.component';
import { CuentasBancarias } from '../ctas';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { CuentaArchivosComponent } from '../cuenta-archivos/cuenta-archivos.component';
import { InfoCuentasDialog } from '../info-cuentas-dialog/info-cuentas-dialog';
import { SettingsService } from '../../../settings/settings.service';
import { InputDialog } from '../../input-dialog/dialog-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

declare var $: any;

@Component({
    selector: 'updateacc-component2',
    templateUrl: './updateacc.component.html',
    styleUrls: ['./updateacc.component.less'],
    standalone: true,
    imports: [
      MatFormFieldModule,
      FormsModule,
      ReactiveFormsModule,
      MatButtonModule,
      CommonModule,
      MatExpansionModule,
      MatTooltipModule,
      MatAutocompleteModule,
      MatIconModule,
      MatInputModule,
      MatOptionModule,
      MatSelectModule,
      MatSlideToggleModule


    ]
})
@Injectable()
export class UpdateAccountCompanyDialog implements OnInit {
  public id: any;
  public banco: any;

  @Input() id_company: any;
  @Input() token: any;
  @Input() parent: any;

  public load_data: any;

  public email: any;
  public validated: boolean = true;
  public validated_status: any;
  public validated_tooltip: any;
  public validated_icon: any;

  public star_class: any;
  public star: any;

  public is_primary_text: any;
  public proveedor: any;

  disabled_delete: any;
  disabled_validator: boolean = false;

  dis: any;

  disabledButton: boolean = true;
  showSpinner: boolean = false;

  public info!: CuentasBancarias;

  @Input() bancos: any;

  @Input() cuentas: any[] = [];

  public run: any;
  public full_name: any;
  public number: any;
  public is_tercero: boolean = false;

  checkingDocuments:boolean=false;
  
  bank_selected: any;
  account_selected: any;

  sw_edit: any;

  valForm: FormGroup;
  valFormB: FormGroup;
  //mio
  myControl = new FormControl();
  filteredOptions!: Observable<any[]>;
  companyRun!: string;

  @Input() accountData: any;

  constructor(
    public snackBar: MatSnackBar,
    fb: FormBuilder,
    public dialog: MatDialog,
    public settings: SettingsService,
  ) {
    let rutValid = new FormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{7,10}[-][0-9K]$'),
      ])
    );
    let accNumber = new FormControl(
      null,
      Validators.compose([
        Validators.required,
        Validators.pattern('^[0-9]{6,12}$'),
      ])
    );

    let emailValid = new FormControl(
      '',
      Validators.compose([
        Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')
      ])
    );

    let fileControl = new FormControl('');

    this.valForm = fb.group({
      bank: ['', Validators.compose([Validators.required])],
      type: ['', Validators.compose([Validators.required])],
      rut: rutValid,
      number: accNumber,
      name: ['', Validators.compose([Validators.required])],
      tercero: new FormControl({ value: false, disabled: true }),
      email: emailValid,
      file: fileControl 
    });

    this.valFormB = fb.group({
      bank: new FormControl({ value: '', disabled: !this.sw_edit }),
      type: new FormControl({ value: '', disabled: !this.sw_edit }),
      number: new FormControl({ value: '', disabled: !this.sw_edit }),
      rut: new FormControl({ value: '', disabled: !this.sw_edit }),
      name: new FormControl({ value: '', disabled: !this.sw_edit }),
      email: new FormControl({ value: '', disabled: !this.sw_edit }),
    });
  }

  initial_load() {}

  async set_principal() {
    this.dis = true;
    //$event.preventDefault();

    this.star = 'star';
    this.star_class = 'add_primary';

    try {
      const body_data: any = await this.settings.get_query(
        2,
        `cliente-inversionista/set-unset-primary-account/${this.id}/`
      );
      var _body: any = body_data._body;
      this.dis = false;
      this.info.reloadAccounts();

      this.infoCuentasDialog(
        "Cuenta agregada",
        "check_circle",
        "Cerrar",
        "Se marcó la cuenta bancaria como pricipal."
      );

    } catch (error) {
      this.infoCuentasDialog(
        "Error al actualizar",
        "cancel",
        "Cerrar",
        "Error al actualizar la cuenta, por favor intente de nuevo.",
        true
      );
    }
  }

  transform_number() {
    let regex = /[^0-9]+/;
    let phone = String(this.valForm.controls['number'].value).replace(
      regex,
      ''
    );
    if (phone != '') {
      return this.valForm.controls['number'].setValue(phone);
    } else {
      this.valForm.controls['number'].reset();
    }
  }

  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.bancos.filter(
      (option: any) => option.name.toLowerCase().includes(filterValue) === true
    );
  }


  filtrar_banco($e: any) {
    this.bank_selected = $e.id;

    let cuenta = { id: '2', name: 'Cuenta RUT' };
    if (this.bank_selected != '26') {
      if (this.cuentas.indexOf(cuenta) != -1) {
        this.cuentas.splice(this.cuentas.indexOf(cuenta), 1);
      }
    } else {
      this.cuentas.push(cuenta);
    }
  }

  async validate_account() {
    this.disabled_validator = true
    const bd: any = await this.settings.get_query(
      2,
      `/validador-de-cuentas/${this.id_company}`,
      this.valForm.value
    );
    if (bd.status === 200) {
      const dialogRef = this.dialog.open(InputDialog, {
        width: '700px',
        autoFocus: false,
      });
      dialogRef.componentInstance.title = 'Información de la validación';
      dialogRef.componentInstance.subtitle = '';
      dialogRef.componentInstance.mensajenegrita = '';
      if (bd._body.success) {
        dialogRef.componentInstance.mensajeprincipal = 'La cuenta se encuentra en validación';
        dialogRef.componentInstance.icon = 'autorenew';
        dialogRef.componentInstance.coloricon = '#289cdf';
      } else {
        let errors_array: string[] = [];
        bd._body.error.map((error: any) => {
          errors_array.push(error);
        });
        dialogRef.componentInstance.mensajeprincipal = errors_array[0];
        dialogRef.componentInstance.icon = 'error';
        dialogRef.componentInstance.coloricon = '#f31633';
      }
    }
  }

  delete_add() {
    let dialogRef = this.dialog.open(CompanyDeleteAccDialog);
    dialogRef.componentInstance.id_acc = this.id;
    dialogRef.componentInstance.info = this.info;
    dialogRef.componentInstance.token = this.token;
  }

  ngOnInit() {
    this.filteredOptions = this.valForm.controls['bank'].valueChanges.pipe(
      startWith(''),
      map((value) => (typeof value === 'string' ? value : value.name)),
      map((name) => (name ? this._filter(name) : this.bancos.slice()))
    );
    if (this.sw_edit == false) {
      this.valForm = this.valFormB;
    }

    console.log("terceros", this.is_tercero)
    this.change_run();



    if (this.accountData) {

      console.log("accountdata", this.accountData)

      this.id = this.accountData.id;
      this.banco = this.accountData.banco;
      this.proveedor = this.accountData.proveedor;
      this.email = this.accountData.email;
      this.validated_status = this.accountData.validated_status;
      this.validated_tooltip = this.accountData.validated_tooltip;
      this.validated_icon = this.accountData.validated_icon;
      this.sw_edit = this.accountData.sw_edit;
      this.star = this.accountData.star;
      this.star_class = this.accountData.star_class;
      this.is_primary_text = this.accountData.is_primary_text;
      this.disabled_delete = this.accountData.disabled_delete;
      this.disabledButton = this.accountData.disabledButton;
      this.run = this.accountData.run;
      this.number = this.accountData.number;
      this.is_tercero = this.accountData.is_tercero;
      console.log(this.is_tercero);
      this.full_name = this.accountData.full_name;
      this.bank_selected = this.accountData.bank_selected;
      this.account_selected = this.accountData.account_selected;
      this.token = this.accountData.token;
      this.bancos = this.accountData.bancos;
      this.cuentas = this.accountData.cuentas;
      this.id_company = this.accountData.id_company;
      this.companyRun = this.accountData.companyRun;
      this.info = this.accountData.info;
      
      // Asignar valores al formulario
      this.valForm.controls['rut'].setValue(this.run);
      this.valForm.controls['number'].setValue(this.number);
      this.valForm.controls['name'].setValue(this.full_name);
      this.valForm.controls['bank'].setValue(this.banco);
      this.valForm.controls['tercero'].setValue(this.is_tercero);
      this.valForm.controls['email'].setValue(this.email);
      this.valForm.controls['type'].setValue(this.account_selected);
    }

    this.initialTercerosState = this.is_tercero;

    if (this.is_tercero && !this.initialTercerosState) {
      this.valForm.get('file')?.setValidators([Validators.required]);
      this.valForm.get('file')?.updateValueAndValidity();
    }
  }

  change_run(event?: any) {
    let inputValue = event ? event.target.value || '' : this.valForm.get('rut')?.value || '';
    
    // Remover todo lo que no sea números o K/k
    inputValue = inputValue.replace(/[^0-9Kk]/g, '');
    
    // Convertir k minúscula a mayúscula
    inputValue = inputValue.replace(/k/g, 'K');
    
    // Separar números y dígito verificador
    if (inputValue.length > 1) {
      let numbers = inputValue.slice(0, -1);
      let verificador = inputValue.slice(-1);
      
      // Limitar a máximo 8 números antes del dígito verificador
      if (numbers.length > 8) {
        numbers = numbers.slice(0, 8);
      }
      
      // Formar RUT con guión
      inputValue = numbers + '-' + verificador;
    }
    
    // Actualizar el valor en el formulario
    this.valForm.get('rut')?.setValue(inputValue);
    this.run = inputValue;
    
    // Validar si es cuenta de terceros
    if(this.companyRun != inputValue && inputValue.length > 8){
      this.valForm.get('tercero')?.setValue(true);
      this.valForm.get('tercero')?.disable()
      this.is_tercero = true;
      this.showFileInput = true;
    }
    else{
      this.valForm.get('tercero')?.setValue(false)
    }
  }

  async submitForm($ev: any, value: any) {
    $ev.preventDefault();

    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }

    if (!this.isFormValid()) {
      if (this.is_tercero && !this.fileSelected && this.showFileInput) {

        this.valForm.get('file')?.markAsTouched();
        this.valForm.get('file')?.setErrors({ required: true });

        this.infoCuentasDialog(
          "¡Atención!",
          "warning",
          "Cerrar",
          "Debes adjuntar la documentación de respaldo.",
          true
        );
      }
      return;
    }

    try {
      this.showSpinner = true;

      let payload: any;

        value['email'] = this.cleanEmail(value.email)
        value['bank'] = this.bank_selected;
        value['tercero'] = this.is_tercero;

        if (this.is_tercero && this.selectedFile) {
          const formData = new FormData();
          formData.append('email', this.cleanEmail(value.email));
          formData.append('bank', this.bank_selected);
          formData.append('tercero', this.is_tercero.toString());
          formData.append('type', value.type);
          formData.append('rut', value.rut);
          formData.append('number', value.number);
          formData.append('name', value.name);
          formData.append('file', this.selectedFile);
          payload = formData;
        } else {
          payload = value;
        }

        console.log("AQUI PAYLOADDDD", payload);

      const bd: any = await this.settings.get_query(
        3,
        'cliente-inversionista/account/' + this.id + '/',
        payload
      );
      var body_data: any = bd._body;
      switch (bd.status) {
        case 201:
        case 200:
          this.disabledButton = false;
          this.showSpinner = false;

        this.infoCuentasDialog(
          "Cuenta actualizada",
          "check_circle",
          "Cerrar",
          "Se actualizó la cuenta de forma exitosa."
        );

          // this.banco = body_data.account.bank.name;
          // this.proveedor = body_data.account.name;

          if(parent) {
            this.parent?.load_accounts();
          }

          break;
        default:
          break;
      }
    } catch (bd: any) {
      console.log(bd);
      this.infoCuentasDialog(
        "Ocurrió un error",
        "cancel",
        "Cerrar",
        "Error al actualizar la cuenta, por favor intente de nuevo.",
        true
      );
      this.showSpinner = false;
    }
  }

  archivo_terceros(id_cuenta: any) {
    let dialogRef = this.dialog.open(CuentaArchivosComponent, {
      width: '600px',
      autoFocus: false,
      //height: '200px'
    });
    dialogRef.componentInstance.id_cuenta = id_cuenta;

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  cleanEmail(email: string): string {
    return email.replace(/\s+/g, '');
  }

  isFormValid(): boolean {
    if (!this.valForm.valid) {
      return false;
    }
    
    // Si es cuenta de terceros, verificar que tenga documentos
    if (this.is_tercero && !this.initialTercerosState && !this.fileSelected) {
      this.valForm.get('file')?.setValidators([Validators.required]);
      return false;
    }
    
    return true;
  }

    // Función para formatear nombre (solo letras y espacios)
  formatAccountName(event?: any) {
    let inputValue =  event.target.value || '';
    
    // Remover todo lo que no sean letras, espacios, acentos y ñ
    inputValue = inputValue.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ\s]/g, '');
    
    // Actualizar el valor en el formulario
    this.valForm.get('name')?.setValue(inputValue);
    this.full_name = inputValue;
  }

  // Función para formatear número de cuenta (solo números)
  formatAccountNumber(event: any) {
    let inputValue = event.target.value || '';
    
    // Remover todo lo que no sea números
    inputValue = inputValue.replace(/[^0-9]/g, '');
    
    // Actualizar el valor en el formulario
    this.valForm.get('number')?.setValue(inputValue);
    this.number = inputValue;
  }


  infoCuentasDialog(title:any,icon:any,buttonText:any, message?:any, isError?: any) {
    const dialogRef = this.dialog.open(InfoCuentasDialog, {
      width: '700px',
      disableClose: true,
      panelClass: 'custom-dialog',
      autoFocus: false,
    });
    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.icon = icon;
    dialogRef.componentInstance.buttonText = buttonText;
    dialogRef.componentInstance.message = message;
    dialogRef.componentInstance.isError = isError;
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  placeholder: string = '';
  fileSelected: boolean = false;
  selectedFile: File | null = null;
  initialTercerosState: boolean = false;
  showFileInput: boolean = false;

  onFileSelected(event: any) {
    const files = event.target.files;
    
    this.valForm.get('file')?.markAsTouched();
    
    if (files && files.length > 0) {
      this.selectedFile = files[0];
      this.placeholder = files[0].name;
      this.fileSelected = true;
      this.valForm.get('file')?.setValue(files[0].name);
      this.valForm.get('file')?.setErrors(null);
    } else {
      if (this.showFileInput && this.is_tercero && !this.fileSelected) {
        this.valForm.get('file')?.setErrors({ required: true });
      }
    }
  }
  
}
